import anime from 'animejs';

let quoteBtn = document.querySelector("#quote-btn");
let quoteBlock = document.querySelector(".quote-block");

let quoteHeightwrap = document.querySelector(".quote-block__height-wrap");
let quoteText = document.querySelector(".quote-block__quote");
let quoteAuthor = document.querySelector(".quote-block__subline");
let quoteBg = document.querySelector(".quote-block__backdrop");

// let catchedData = "";
// let quotesTitle = [];
// let quotesAuthors = [];

let initQuote = true;


// all animations
var hideQuote;
var showQuote;

// all waypoints
var slideInAnimation;

// init all Anime.js animations
function addAnimations() {
	hideQuote = anime.timeline({
		easing: 'easeInQuart',
		duration: 750,
		autoplay: false,
		complete: function() {
			showQuote.play();
		},
		});
		
	hideQuote 	.add({
						targets: quoteBg,
						easing: 'easeInOutQuart',
						translateX: ["0%","-25%"],
					})
					.add({
						targets: quoteBtn,
						opacity: [1,0],
						duration: 350,
					}, 0)
					.add({
						targets: quoteText,
						opacity: [1,0],
						translateX: ["0%","-10%"],
					}, 150)
					.add({
						targets: quoteAuthor,
						opacity: [1,0],
						translateX: ["0%","-10%"],
					}, 250);
					
	showQuote = anime.timeline({
		easing: 'easeOutQuart',
		duration: 750,
		autoplay: false,
		begin: function() {
			loadNewQuote();
		},
	});
	
	showQuote 	
		.add({
			targets: quoteBg,
			easing: 'easeInOutQuart',
			translateX: ["-25%","0%"],
		})
		.add({
			targets: quoteText,
			opacity: [0,1],
			translateX: ["-10%","0%"],
		}, 150)
		.add({
			targets: quoteAuthor,
			opacity: [0,1],
			translateX: ["-10%","0%"],
		}, 250)
		.add({
			targets: quoteBtn,
			opacity: [0,1],
			duration: 350,
		},150);
}

// init all waypoints
function addWaypoints() {
	// anchor for fireing initial slide in animation
	slideInAnimation = new Waypoint({
		element: quoteBlock,
		handler: function(direction) {
			showQuote.play();
			this.destroy();
		},
		offset: "50%",
	})
}

// load a new quote from quotes array 
function loadNewQuote() {
	console.log("Load new Quote");
	
	// find out which number ist the (in CP) selected Quote
	let currentQuote = quoteText.innerText;
	let current = 0;
	// debugger
	
	for (let i = 0; i < quotesTitle.length; i++) {
		if( currentQuote == "»" + quotesTitle[i] + "«" ) {
			current = i;
		}
	}

	// take the next quote out of all quotes except on init
	if(initQuote) {
		initQuote = false;
	}
	else {
		current++;
		current %= quotesTitle.length;
	}

	
	// set the new text
	quoteText.innerText = "»" + quotesTitle[current] + "«";
	quoteAuthor.innerText = quotesAuthors[current];

	// calculate the new height for height animation
	var tmp_style = window.getComputedStyle(quoteText);
	var tmp_mbot = parseInt(tmp_style.marginBottom);
	let tempHeight = (tmp_mbot + quoteText.clientHeight + quoteAuthor.clientHeight) + 'px';
	
	// set the new height (CSS transition will do the animation)
	quoteHeightwrap.style.height = tempHeight;
}



// create graphql request, send it and put it into an js array




// add all eventlisteners for buttons etc.
function addListeners() {
	quoteBtn.addEventListener("click", function() {
		console.log("Press Quote");
		hideQuote.play();
	});
}

// initialize quotes block
function initQuotes() {
	addAnimations();
	addWaypoints();
	addListeners();
}

document.addEventListener('readystatechange', (event) => {
	switch (document.readyState) {
		case "interactive":
			initQuotes();
			break;
	}
});